module.exports = React.addons.TransitionGroup;


//////////////////
// WEBPACK FOOTER
// external "React.addons.TransitionGroup"
// module id = 1561
// module chunks = 0